export const ONE_SURVEY = 'ONE_SURVEY';
